<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('title')">
              <input-widget :placeholder="$t('Title')" :label='false' :model="searchModel" attribute="title"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('comment')">
              <input-widget :placeholder="$t('Comment')" :label='false' :model="searchModel" attribute="comment"/>
            </div>
          </div>
          <div class="search-btn-wrapper text-right">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState, mapActions} = createNamespacedHelpers('cls');

  export default {
    name: "ClsSearch",
    components: {
      InputWidget,
    },
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
      onDateRangeApply() {
        this.searchModel.activityDateRange = this.dateRange
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
